import {
	faAddressBook,
	faEnvelope,
	faMapMarkerAlt,
	faPaperPlane,
	faPhone,
	faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useDispatch } from "react-redux";
import "../Menu.css";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { postDataAPI } from "../utils/fetchData";
import Footer from "./footer";
import Homecarousel from "./homecarousel";
import Navbar from "./navbar";

const ContactUs = () => {
	const dispatch = useDispatch();

	const [formData, setFormData] = useState({
		name: "",
		email: "",
		mobile: "",
		message: "",
	});
	const [errors, setErrors] = useState({});
	const lengthOftext = 200;

	const validateForm = () => {
		const newErrors = {};
		if (!formData.name) {
			newErrors.name = "Name is required.";
		}

		if (!formData.email) {
			newErrors.email = "Email is required.";
		} else if (!/\S+@\S+\.\S+/.test(formData.email)) {
			newErrors.emailInvalid = "Email is invalid.";
		}

		if (!formData.mobile) {
			newErrors.mobile = "Mobile number is required.";
		}

		if (!formData.message) newErrors.message = "Message is required.";
		else if (formData.message < 10)
			newErrors.messageLength = "Message should contain atleast 10 characters";

		setErrors(newErrors);
		// console.log("newErrors", newErrors);
		return Object.keys(newErrors).length === 0;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!validateForm()) return;
		dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
		try {
			const res = await postDataAPI("createcontactus", formData);
			if (res.status === 200) {
				alert("Thank you for your interest. We will get back to you soon");
				window.location.reload();
			}
		} catch (err) {
			dispatch({
				type: GLOBALTYPES.ALERT,
				payload: { error: err.response.data.msg },
			});
		}
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prevState) => ({
			...prevState,
			[name]: value,
		}));
	};

	const handlePhoneChange = (value) => {
		setFormData({ ...formData, mobile: value });
	};
	return (
		<>
			<Navbar />
			<Homecarousel />

			<div className="row" style={{ margin: "100px 20px 100px 30px" }}>
				<div className="col-sm-6 col-md-6 col-lg-3">
					<div className="info-item" style={{ marginTop: "0px" }}>
						<div className="cs-icon1">
							<FontAwesomeIcon className="cs-icon2" icon={faAddressBook} />
						</div>
						<span>
							<b>Phone Number</b> <br />
							+91 98480 34740
						</span>
					</div>
					<div className="info-item">
						<div className="cs-icon1">
							<FontAwesomeIcon className="cs-icon2" icon={faEnvelope} />
						</div>
						<span>
							<b>Email</b> <br />
							info@krishigap.com
						</span>
					</div>
					<div className="info-item">
						<div className="cs-icon1">
							<FontAwesomeIcon className="cs-icon2" icon={faMapMarkerAlt} />
						</div>
						<span>
							<b>Location</b>
							<p>
								Krishigap Digital Solutions Pvt Ltd (CIN
								:U62013TS2023PTC172865), <br /> House No 5-106/281B, Narsing
								Municipality, Manchirevula, K.V Ranga Reddy, Hyderabad,
								Telangana, 500075.
							</p>
						</span>
					</div>
				</div>
				<div
					className="col-sm-6 col-md-6 col-lg-3"
					style={{ marginBottom: "20px" }}>
					<iframe
						title="Location"
						src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3807.65940366535!2d78.49873941384925!3d17.38011470759183!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb984b1d296f4f%3A0x89139a561673ed35!2s3-4%2C%20Ajantha%20Colony%2C%20Narayanguda%2C%20Hyderabad%2C%20Telangana%20500036!5e0!3m2!1sen!2sin!4v1665507300441!5m2!1sen!2sin"
						width="100%"
						height="450px"
						style={{ border: 0 }}
						allowFullScreen=""
						loading="lazy"
						referrerPolicy="no-referrer-when-downgrade"
					/>
				</div>

				{/* <div className="col-1"></div>
			</div>
			<div className="row">
				<div className="col-1"></div> */}
				<div className="col-sm-12 col-md-12 col-lg-5">
					<h2
						style={{
							color: "rgb(21, 34, 44)",
							fontFamily: "Rajdhani, sans-serif",
							fontSize: "30px",
							fontWeight: "700",
						}}>
						Contact Us
					</h2>
					{/* <p
						style={{
							marginTop: "20px",
							fontFamily: "Rubik, sans-serif",
							fontSize: "16px",
							color: "rgb(97,102,102)",
							fontWeight: "400",
							marginBottom: "20px",
						}}>
						Constimes section description here
					</p> */}
					<form className="contact-form" onSubmit={handleSubmit}>
						<div className="form-group input-box">
							<input
								type="text"
								id="name"
								name="name"
								maxLength={lengthOftext}
								value={formData.name}
								placeholder="Your Name"
								onChange={handleInputChange}
							/>
							<FontAwesomeIcon
								style={{ width: "70px" }}
								className="cs-icon"
								icon={faUser}
							/>
						</div>
						<p
							style={{
								visibility: errors.name ? "visible" : "hidden",
							}}
							className="error-message">
							Name is required.
						</p>
						<div className="form-group input-box">
							<input
								type="text"
								onChange={handleInputChange}
								id="email"
								value={formData.email}
								name="email"
								maxLength={lengthOftext}
								placeholder="Your Email"
							/>
							<FontAwesomeIcon
								style={{ width: "70px" }}
								className="cs-icon"
								icon={faPaperPlane}
							/>
						</div>
						<p
							className="error-message"
							style={{
								visibility:
									errors.email || errors.emailInvalid ? "visible" : "hidden",
							}}>
							{errors.email ? errors.email : errors.emailInvalid}
							{!errors.email && !errors.emailInvalid && "Text"}
						</p>
						<div className="form-group input-box">
							<PhoneInput
								// className="col-11"
								country={"in"}
								type="tel"
								name="mobile"
								value={formData.mobile}
								onChange={handlePhoneChange}
								placeholder="Phone Number"
								maxLength={lengthOftext}
								inputStyle={{
									border: "none",
									boxShadow: "none",
								}}
							/>
							<FontAwesomeIcon
								style={{ width: "70px" }}
								className="cs-icon"
								icon={faPhone}
							/>
						</div>
						<p
							style={{
								visibility: errors.mobile ? "visible" : "hidden",
							}}
							className="error-message">
							Mobile is required.
						</p>
						<div className="form-group input-box">
							<textarea
								id="message"
								name="message"
								value={formData.message}
								onChange={handleInputChange}
								maxLength={lengthOftext}
								rows="4"
								placeholder="Message"></textarea>
							<FontAwesomeIcon
								style={{ width: "70px" }}
								className="cs-icon top-right"
								icon={faEnvelope}
							/>
						</div>
						<p
							className="error-message"
							style={{
								visibility:
									errors.message || errors.messageLength ? "visible" : "hidden",
							}}>
							{errors.message ? errors.message : errors.messageLength}
							{!errors.message && !errors.messageLength && "Text"}
						</p>
						<button type="submit" className="hover-button">
							SUBMIT
						</button>
					</form>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default ContactUs;
